import { createSlice } from '@reduxjs/toolkit'

import { customerApi } from '../services/customer'

const initialState = {
    customerContacts: [],
    contactId: null,
}

export const contactsSlice = createSlice({
    name: 'contactsSlice',
    initialState,
    reducers: {
        setContactId: (state, action) => {
            state.contactId = action.payload
        },
        unsetContactId: (state) => {
            state.contactId = null
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(customerApi.endpoints.getContact.matchFulfilled, (state, { payload }) => {
            state.contactId = payload.contactId
        })
    },
})

export const selectAllContacts = (state) => state.contactsSlice.allContacts

export const selectContactId = (state) => state.contactsSlice.contactId

export const { setContactId, unsetContactId } = contactsSlice.actions

export default contactsSlice.reducer
